import { getEnvConfig } from '@app/env.config';
import {
  getZendeskEnvFromEnvironment,
  ZENDESK_ENVS,
} from '@app/helpers/environment';
import zendeskSandboxFields from '@app/constants/messages/zendesk.config.sandbox';

export default function staticConfigs() {
  const zendeskEnv = getZendeskEnvFromEnvironment(getEnvConfig());
  return {
    messages: zendeskEnv !== ZENDESK_ENVS.PROD ? zendeskSandboxFields : null,
  };
}
